import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInMins = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMins < 1) return "just now";
  if (diffInMins < 60) return `${diffInMins}m ago`;
  if (diffInHours < 24) return `${diffInHours}h ago`;
  if (diffInDays < 7) return `${diffInDays}d ago`;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
}

export function formatDateTime(date: Date): string {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Format a due date in absolute format (DD-MMM or DD-MMM-YY)
 * @param date The date to format
 * @returns Formatted string like "22-Dec" or "22-Dec-26" (with year if different from current year)
 */
export function formatDueDateAbsolute(date: Date): string {
  const now = new Date();
  const dueDate = new Date(date);

  // Get day with leading zero (01-31)
  const day = String(dueDate.getDate()).padStart(2, '0');

  // Get short month name (Jan, Feb, etc.)
  const month = dueDate.toLocaleDateString("en-US", { month: "short" });

  // Include year only if different from current year
  if (dueDate.getFullYear() !== now.getFullYear()) {
    const year = String(dueDate.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  return `${day}-${month}`;
}
